import { defineComponent as _defineComponent } from 'vue'
import { toRefs, useContext } from '@nuxtjs/composition-api';

interface Props {
    theme?: 'light' | 'dark',
    disabled?: boolean,
    type?: 'outline' | 'tonal' | 'icon',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Theme',
  props: {
    theme: null,
    disabled: { type: Boolean },
    type: null
  },
  setup(__props: any) {

const props = __props as {
    theme?: 'light' | 'dark',
    disabled?: boolean,
    type?: 'outline' | 'tonal' | 'icon',
};



const {
    theme,
    disabled,
    type,
} = toRefs(props);

const modes = ['light', 'dark'] as ['light', 'dark'];
const { $colorMode } = useContext();

const onModeChange = (value: unknown) => {
    $colorMode.preference = value as string;
};

return { __sfc: true,props, theme, disabled, type, modes, $colorMode, onModeChange }
}

})